const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const monthOptions = monthNames.map((label) => ({
  label,
  value: label.toUpperCase(),
}))

export type MonthsWithDaysType = {
  label: string
  abbr: string
  days: number
}

const monthsWithDays = [
  {
    label: 'January',
    abbr: 'Jan',
    days: 31,
  },
  {
    label: 'February',
    abbr: 'Feb',
    days: 29,
  },
  {
    label: 'March',
    abbr: 'Mar',
    days: 31,
  },
  {
    label: 'April',
    abbr: 'Apr',
    days: 30,
  },
  {
    label: 'May',
    abbr: 'May',
    days: 31,
  },
  {
    label: 'June',
    abbr: 'Jun',
    days: 30,
  },
  {
    label: 'July',
    abbr: 'Jul',
    days: 31,
  },
  {
    label: 'August',
    abbr: 'Aug',
    days: 31,
  },
  {
    label: 'September',
    abbr: 'Sep',
    days: 30,
  },
  {
    label: 'October',
    abbr: 'Oct',
    days: 31,
  },
  {
    label: 'November',
    abbr: 'Nov',
    days: 30,
  },
  {
    label: 'December',
    abbr: 'Dec',
    days: 31,
  },
]

const abbreviatedMonths = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

export { monthNames, monthsWithDays, abbreviatedMonths }
